var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[_vm._m(0),_c('div',{staticClass:"maintenance-title"},[_vm._v(_vm._s(_vm.detail.title))]),_c('div',{staticClass:"maintenance-desc"},[_vm._v(_vm._s(_vm.detail.desc))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-container"},[_c('img',{attrs:{"src":require("@/assets/maintenance/maintenance.svg"),"alt":"maintenance image"}})])
}]

export { render, staticRenderFns }